const ranking = [
  { title: '顶流男星深夜密会神秘女子实锤', heat: '986万', trend: 'up', tag: '新' },
  { title: '选秀节目投票系统造假事件全记录', heat: '872万', trend: 'up', tag: '爆' },
  { title: '知名女星千万合约纠纷内幕深扒', heat: '765万', trend: 'up', tag: '热' },
  { title: '娱乐圈夫妻档离婚第三者身份曝光', heat: '698万', trend: 'stable', tag: '热' },
  { title: '综艺录制现场导演与嘉宾冲突视频', heat: '543万', trend: 'down', tag: '' },
  { title: '当红小花片场耍大牌多人佐证实锤', heat: '489万', trend: 'up', tag: '新' },
];

export default function Ranking() {
  return (
    <section id="ranking" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10 md:mb-14">
          <h2 className="text-2xl md:text-3xl font-bold text-foreground-950 mb-3">
            热搜黑料榜
          </h2>
          <p className="text-foreground-500 text-sm">实时热度排行 · 全网瓜料风向标</p>
        </div>

        <div className="bg-background-50 border border-background-200/70 rounded-xl overflow-hidden">
          {ranking.map((item, i) => (
            <a
              key={i}
              href="#carousel"
              className={`flex items-center gap-4 px-5 py-4 hover:bg-background-100 transition-colors cursor-pointer ${
                i < ranking.length - 1 ? 'border-b border-background-200/60' : ''
              }`}
            >
              <div
                className={`w-8 h-8 flex items-center justify-center rounded-lg text-sm font-bold flex-shrink-0 ${
                  i < 3
                    ? 'bg-primary-500 text-white'
                    : 'bg-secondary-100 text-secondary-600'
                }`}
              >
                {i + 1}
              </div>
              <div className="flex-1 min-w-0">
                <div className="flex items-center gap-2">
                  <span className="text-sm font-medium text-foreground-800 truncate">
                    {item.title}
                  </span>
                  {item.tag && (
                    <span
                      className={`px-1.5 py-0.5 text-[10px] font-bold rounded whitespace-nowrap flex-shrink-0 ${
                        item.tag === '爆'
                          ? 'bg-primary-500 text-white'
                          : item.tag === '热'
                          ? 'bg-accent-500 text-white'
                          : 'bg-accent-100 text-accent-700'
                      }`}
                    >
                      {item.tag}
                    </span>
                  )}
                </div>
              </div>
              <div className="flex items-center gap-1.5 flex-shrink-0">
                <i
                  className={`text-xs ${
                    item.trend === 'up'
                      ? 'ri-arrow-up-line text-primary-500'
                      : item.trend === 'down'
                      ? 'ri-arrow-down-line text-foreground-400'
                      : 'ri-subtract-line text-foreground-400'
                  }`}
                ></i>
                <span className="text-xs font-semibold text-primary-600 whitespace-nowrap">
                  {item.heat}热度
                </span>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}